type ImageCardProps = {
    children: React.ReactNode;
    className?: string;
};

const ImageCard = (props: ImageCardProps) => {
    return (
        <div className={`relative overflow-hidden rounded-[4px] cursor-pointer w-full bg-theme-surface ${props.className ?? ""}`}>
            {props.children}
        </div>
    )
}

export default ImageCard
